import { SharingService } from './services/sharing.service';
import { ImageComponent } from './core/image/image.component';
import { ParametrosComponent } from './components/parametros/parametros-component';
import { PasswordComponent } from './components/password/password.component';
import { LockersDetailsComponent } from './components/lockers-details/lockers-details.component';
import { LockersEditComponent } from './components/lockers-edit/lockers-edit.component';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { RatingComponent } from './components/users/rating.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardLuggageComponent } from './components/dashboardLuggage/dashboardLuggage.component';
import { DashboardOfficeComponent } from './components/dashboardOffice/dashboardOffice.component';
import { HeaderComponent } from './core/header/header.component';
import { UsersComponent } from './components/users/users.component';
import { SitesComponent } from './components/sites/sites-component';
import { LockersComponent } from './components/lockers/lockers.component';
import { CustomMessagesService } from './services/custom-messages.service';
import { EntitiesComponent } from './components/entities/entities.component';
import { EntitiesFormComponent } from './components/entities-form/entities-form.component';
import { ExcelModule, GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FileSelectModule } from '@progress/kendo-angular-upload';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { IntlModule } from '@progress/kendo-angular-intl';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { MessageService } from '@progress/kendo-angular-l10n';
import { DialogService, WindowModule } from '@progress/kendo-angular-dialog';
import { DialogModule } from "@progress/kendo-angular-dialog";
import { GaugesModule } from "@progress/kendo-angular-gauges";
import { DatePipe } from '@angular/common';
import { LoadingInterceptor } from './services/loader/loading.interceptor';
import 'hammerjs';
import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/pt/all';
import { SiteFormComponent } from './components/sites-form/sites-form.component';
import { MasterComponent } from './components/master/master.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './core/auth/auth.guard';
import { AuthService } from './core/auth/auth.service';
import { TempStateService } from './core/navigation/tempState.service';
import { UsersFormComponent } from './components/users-form/users-form.component';
import { HttpErrorInterceptor } from './core/http/http-request-error-interceptor';
import { LockersFormComponent } from './components/lockers-form/lockers-form.component';
import { UsersImportFormComponent } from './components/users-import-form/users-import-form.component';
import { ChangePasswordComponent } from './components/changepassword/changepassword.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
import { MenusModule } from '@progress/kendo-angular-menu';
import localePt from '@angular/common/locales/pt';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ProfileImageComponent } from './components/profileImg/profileImg.component';
import { ModulesFormComponent } from './components/modules-form/modules-form.component';
import { TeamsComponent } from './components/teams/teams-component';
import { TeamsFormComponent } from './components/teams-form/teams-form.component';
import { MovementsComponent } from './components/movements/movements.component';
import { ReservationsComponent } from './components/reservations/reservations.component';
import { ReservationsPaymentComponent } from './components/reservations-payment/reservations-payment.component';
import { ReservationsTokenComponent } from './components/reservations-token/reservations-token.component';
import { ReservationsInvoiceComponent } from './components/reservations-invoice/reservations-invoice.component';
import { PagamentosComponent } from './components/pagamentos/pagamentos.component';
import { VersoesComponent } from './components/versoes/versoes.component';


const drawerRoutes = [
    {
        path: '',
        component: MasterComponent,
        canActivateChild: [AuthGuard],
        children: [

            { path: '', component: DashboardComponent },
            { path: 'dashboardlug', component: DashboardLuggageComponent },
            { path: 'dashboardoffice', component: DashboardOfficeComponent },
            { path: 'sites', component: SitesComponent },
            { path: 'lockers', component: LockersComponent },
            { path: 'parameters', component: ParametrosComponent },
            { path: 'users', component: UsersComponent },
            { path: 'teams', component: TeamsComponent },
            { path: 'changepass', component: ChangePasswordComponent },
            { path: 'entities', component: EntitiesComponent },
            { path: 'movements', component: MovementsComponent },
            { path: 'reservations', component: ReservationsComponent },
            { path: 'payments', component: PagamentosComponent },
        ]
    },
    { path: 'login', component: LoginComponent },
    { path: 'recover-pass', component: RecoverPasswordComponent },

    { path: 'pass', component: PasswordComponent },
    { path: '**', redirectTo: '/' }
];

registerLocaleData(localePt);
registerLocaleData(localeFr);

@NgModule({
    declarations: [
        AppComponent,
        RatingComponent,
        DashboardLuggageComponent,
        DashboardOfficeComponent,
        LockersComponent,
        HeaderComponent,
        UsersComponent,
        SitesComponent,
        SiteFormComponent,
        UsersImportFormComponent,
        LockersDetailsComponent,
        LockersEditComponent,
        UsersFormComponent,
        MovementsComponent,
        MasterComponent,
        LoginComponent,
        ParametrosComponent,
        PasswordComponent,
        ImageComponent,
        ProfileImageComponent,
        LockersFormComponent,
        ChangePasswordComponent,
        RecoverPasswordComponent,
        EntitiesComponent,
        EntitiesFormComponent,
        SpinnerComponent,
        ModulesFormComponent,
        TeamsComponent,
        TeamsFormComponent,
        ReservationsComponent,
        ReservationsPaymentComponent,
        ReservationsTokenComponent,
        ReservationsInvoiceComponent,
        PagamentosComponent,
        VersoesComponent

    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        GaugesModule,
        ReactiveFormsModule,
        GridModule,
        PDFModule,
        ExcelModule,
        LabelModule,
        LayoutModule,
        SchedulerModule,
        ButtonsModule,
        EditorModule,
        FileSelectModule,
        HttpClientModule,
        ChartsModule,
        DialogModule,
        IntlModule,
        WindowModule,
        DateInputsModule,
        InputsModule,
        DropDownsModule,
        RouterModule.forRoot(drawerRoutes, { useHash: true }),
        NotificationModule,
        MenusModule
    ],
    providers: [
        { provide: MessageService, useClass: CustomMessagesService },
        { provide: DialogService },
        AuthService,
        SharingService,
        AuthGuard,
        TempStateService,
        DatePipe,
        { provide: LOCALE_ID, useValue: 'pt' }
        , {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
